/* ****************************************************************************
* File:         garmin.global-store.js
* Description:  Garmin Global  Storage API
* Revision:     $Revision: 6307 $
* Last Edited:  $Date: 2013-03-13 19:49:46 -0500 (Wed, 13 Mar 2013) $
*
***************************************************************************** */
;(function ( window, document, undefined ) {
    function Store () {
      this.init();
    }

    Store.prototype.init = function () {
      this.cookieName = 'GarminGlobalStorage';
    };

    Store.prototype.getCookie = function (cookieName) {
      return cookieName;
    };

    Store.prototype.getGlobal = function (path) {
      path = path && path.length ? 'global.' + path : 'global';
      return this._get(path);
    };

    Store.prototype.getApplication = function (path) {
      path = path && path.length ? 'application.' + path : 'application';
      return this._get(path);
    };

    Store.prototype._get = function (path) {
      var branch = this._getStore();
      var keys   = path.split('.');
      for (var i = 0, len = keys.length; i < len; i++) {
        var key = keys[i];
        if (branch.hasOwnProperty(key)){
          branch = branch[key];
        }
        else {
          return false;
        }
      }
      return branch;
    };

    Store.prototype.setGlobal = function (path, value) {
      path = path && path.length ? 'global.' + path : 'global';
      return this._set(path, value);
    };

    Store.prototype.setApplication = function (path, value) {
      path = path && path.length ? 'application.' + path : 'application';
      return this._set(path, value);
    };

    Store.prototype._set = function (path, value){
      var branch = this._getStore();
      var keys   = path.split('.');
      for (var i = 0, len = keys.length; i < len; i++) {
        var key = keys[i];
        if (i == len - 1){
          branch[key] = value;
        }
        else {
          if (branch.hasOwnProperty(key)){
            branch = branch[key];
          }
          else {
            branch = branch[key] = {};
          }
        }
      }
      return this._setStore();
    };

    Store.prototype.delGlobal = function (path) {
      path = path && path.length ? 'global.' + path : 'global';
      return this._del(path);
    };

    Store.prototype.delApplication = function (path) {
      path = path && path.length ? 'application.' + path : 'application';
      return this._del(path);
    };

    Store.prototype._del = function (path){
      var branch = this._getStore();
      var keys   = path.split('.');
      for (var i = 0, len = keys.length; i < len; i++) {
        var key = keys[i];
        if (i == len - 1){
          delete branch[key];
        }
        else {
          if (branch.hasOwnProperty(key)){
            branch = branch[key];
          }
          else {
            branch = branch[key] = {};
          }
        }
      }
      return this._setStore();
    };

    Store.prototype._getStore = function (){
      var store = this.getCookie(this.cookieName);
      this.data = store ? JSON.parse(store) : {};
      return this.data;
    };

    Store.prototype._setStore = function (){
      var store = this.data;
      this.setCookie(this.cookieName, JSON.stringify(store), 3650);
      return store;
    };

    Store.prototype.getCookie = function(cookieName){
      var cookies = document.cookie.split(';');
      for ( var i = 0, len=cookies.length; i < len; i++ ){
        var cookie = cookies[i].split('=');
        var name   = cookie[0].replace(/^\s+|\s+$/g,'');
        if ( name == cookieName ){
          return unescape(cookie[1]);
        }
      }
    };

    Store.prototype.setCookie = function(cookieName, value, exdays) {
      var exdate = new Date();
      exdate.setDate(exdate.getDate() + exdays);
      var c_value = escape(value) + ((exdays==null) ? "" : "; expires="+exdate.toUTCString() + ";domain=.garmin.com;path=/");
      document.cookie = cookieName + "=" + c_value;
    }

    if ( !('garminGlobalStore' in window) ){
      window.garminGlobalStore = {};
      try {
        window.garminGlobalStore = new Store();
      }
      catch (e){}
    }
})( window, document );
/*
garminGlobalStore.setGlobal('test.test.test', 'path');
garminGlobalStore.setGlobal('test.test', {"test": 'path/object'});
garminGlobalStore.setApplication('buy.cart.items', '10');
garminLog(garminGlobalStore.getGlobal());
garminLog(garminGlobalStore.getGlobal('test.test.test'));
garminLog(garminGlobalStore.getApplication('buy.cart.items'));
garminGlobalStore.delApplication('buy.cart.items');
garminLog(garminGlobalStore.getApplication('buy'));
*/
